import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import RouteGuard from "./components/RouteGuard";
import { routes } from "./routes/routesConfig";
import { useDispatch, useSelector } from "react-redux";
import { triggerForceLogout, updateUserInfo } from "./features/authSlice";
import { useCallback, useEffect } from "react";
import ForceLogoutModal from "./components/ForceLogoutModal";
import socket from "./socket/socket";
import { useBranding } from "./context/BrandingContext";
import MaintenanceScreen from "./components/MaintenanceScreen";
import useSocketEvent from "./socket/useSocketEvent";
import LocationGate from "./components/LocationGate";

const AppLayout = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { maintenanceEnabled, loading: brandingLoading } = useBranding();

  const AUTH_ROUTES = [
    "/login",
    "/reset-password",
    "/new-mpin",
    "/new-password",
    "/verify/mpin",
  ];

  const isAuthRoute = AUTH_ROUTES.some((route) =>
    location.pathname.startsWith(route)
  );

  const userId = useSelector((state) => state.auth.userInfo?._id);

  useEffect(() => {
    const join = () => {
      if (!userId) return;
      socket.emit("join", { userId, portal: "merchant" });
    };
    join();
    socket.on("connect", join);
    return () => socket.off("connect", join);
  }, [userId]);

  const onForceLogout = useCallback((payload) => {
    if (payload?.portal && payload.portal !== "merchant") return;
    dispatch(triggerForceLogout());
  }, [dispatch]);

  const onUserUpdated = useCallback((payload) => {
    if (!userId || String(payload?.userId) !== String(userId)) return;
    if (payload?.user && Object.keys(payload.user).length) {
      dispatch(updateUserInfo(payload.user));
    }
    if (payload?.forceLogout) {
      dispatch(triggerForceLogout());
    }
  }, [dispatch, userId]);

  useSocketEvent("forceLogout", onForceLogout);
  useSocketEvent("user_updated", onUserUpdated);

  useEffect(() => {
    if (isAuthRoute) {
      localStorage.setItem("theme", "light");
      document.documentElement.classList.remove("dark");
      document.documentElement.classList.add("light");
    }
  }, [isAuthRoute]);

  if (!brandingLoading && maintenanceEnabled) {
    return <MaintenanceScreen />;
  }

  return (
    <>
      <ForceLogoutModal />

      <Routes>
        {routes.map((r) => (
          <Route
            key={r.path}
            path={r.path}
            element={
              <RouteGuard isProtected={r.isProtected}>
                {isAuthRoute || !r.isProtected ? (
                  r.element
                ) : (
                  <LocationGate>{r.element}</LocationGate>
                )}
              </RouteGuard>
            }
          />
        ))}
      </Routes>
    </>
  );
};

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
